(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "prop-types", "react", "react-router", "react-transition-group", "./useTransitionHandlers", "../hooks/useActive", "react/jsx-runtime"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("prop-types"), require("react"), require("react-router"), require("react-transition-group"), require("./useTransitionHandlers"), require("../hooks/useActive"), require("react/jsx-runtime"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes, global.react, global.reactRouter, global.reactTransitionGroup, global.useTransitionHandlers, global.useActive, global.jsxRuntime);
    global.StackAnimateRoute = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _propTypes, _react, _reactRouter, _reactTransitionGroup, _useTransitionHandlers, _useActive, _jsxRuntime) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.StackAnimateRoute = StackAnimateRoute;
  _propTypes = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

  function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

  function StackAnimateRoute(_ref) {
    var children = _ref.children;

    var _useContext = (0, _react.useContext)(_reactRouter.__RouterContext),
        _useContext$transitio = _useContext.transitionProps,
        timeout = _useContext$transitio.timeout,
        unmountOnExit = _useContext$transitio.unmountOnExit;

    var history = (0, _reactRouter.useHistory)();
    var location = (0, _reactRouter.useLocation)();
    var active = (0, _useActive.useActive)();

    var _useTransitionHandler = (0, _useTransitionHandlers.useTransitionHandlers)(),
        onEnter = _useTransitionHandler.onEnter,
        onEntered = _useTransitionHandler.onEntered,
        onExit = _useTransitionHandler.onExit,
        onExited = _useTransitionHandler.onExited;

    var _useState = (0, _react.useState)(history.direction ? false : true),
        _useState2 = _slicedToArray(_useState, 2),
        viewIn = _useState2[0],
        setViewIn = _useState2[1];

    var _useMemo = (0, _react.useMemo)(function () {
      var action = history._action || history.action;
      var direction = history._direction || history.direction;

      if (active) {
        if (history._action) delete history._action;
        if (history._direction) delete history._direction;
      }

      return {
        action: action,
        direction: direction
      };
    }, [active, history]),
        action = _useMemo.action,
        direction = _useMemo.direction;

    var classNames = (0, _react.useMemo)(function () {
      var classNames_direction = direction ? " ".concat(direction === null || direction === void 0 ? void 0 : direction.toLowerCase()) : '';
      var classNames_action = " ".concat(action.toLowerCase());
      var addClassNames = classNames_direction + classNames_action;
      return {
        enter: 'enter' + addClassNames,
        enterActive: 'enter-active' + addClassNames,
        enterDone: 'enter-done',
        exit: 'exit' + addClassNames,
        exitActive: 'exit-active' + addClassNames,
        exitDone: 'exit-done'
      }; // `history` does not generate mutation events. `location` is needed for update.
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [action, direction, location]);
    (0, _react.useLayoutEffect)(function () {
      if (viewIn !== active) setViewIn(active);
    }, [active, viewIn]);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactTransitionGroup.CSSTransition, {
      in: viewIn,
      classNames: classNames,
      timeout: timeout,
      unmountOnExit: unmountOnExit,
      onEnter: onEnter // onEntering={onEntering}
      ,
      onEntered: onEntered,
      onExit: onExit // onExiting={onExiting}
      ,
      onExited: onExited,
      children: children
    });
  }

  StackAnimateRoute.propTypes = {
    children: _propTypes.default.node
  };
});